import { graphql, HeadProps } from 'gatsby';
import { useEffect, useMemo } from 'react';
import { PageComponents } from '../components/episerver/page';
import { Seo } from '../components/seo';
import { PageContextType } from '../global';
import { usePageContext } from '../contexts/PageProvider';
import { SITE_PRODUCTION_URL } from '../constants/global';

const ContentPageTemplate = ({ pageContext: ssrPageContext, data }) => {
  const {
    allOptimizelyTemplatePageContentChildren: { edges: templatePageData = null },
    allOptimizelyHomePageContent: { edges: HomepageData = null },
    allOptimizelyStoresContent: { edges: OptimizelyStoresContent = null },
    allOptimizelyHomePageContentChildren: { edges: OptimizelyHomePageContentChildren = null },
    allOptimizelyLocationSearchPageContentChildren: { edges: LocationSearchPageContent = null }
  } = data;

  const mainDataArray = OptimizelyHomePageContentChildren?.concat(HomepageData)
    ?.concat(LocationSearchPageContent)
    ?.concat(templatePageData)
    ?.concat(OptimizelyStoresContent);
  const { pageContext, setPageExternalImages } = usePageContext();
  const { endpoint, productsImages } = ssrPageContext;
  const pageContentData = useMemo(() => {
    if (mainDataArray && mainDataArray.length) {
      let contentData = mainDataArray.find(
        (content) => content.node?.contentLink?.url?.replace(SITE_PRODUCTION_URL, '') == pageContext?.slug
      );
      //add StoreMapLocatorBlock to contentBlocks
      if (contentData && contentData?.node?.locationType === 0) {
        contentData.node.contentBlocks = [
          {
            contentLink: {
              expanded: {
                contentType: ['Block', 'StoreMapLocatorBlock'],
                stores: OptimizelyStoresContent.sort((a, b) => a.name?.localeCompare(b.name))
              }
            }
          }
        ];
      }

      if (contentData && endpoint === 'allOptimizelyHomePageContentChildren' && contentData?.node?.locationType === 1) {
        let selectedNodeBlock =
          contentData.node?.contentBlocksTop?.find((block) =>
            block?.contentLink?.expanded?.contentType?.includes('AnchorLinksBlock')
          )?.contentLink?.expanded || null;

        const hotels = data['allOptimizelyHotelsContent'].edges;
        hotels.sort((a, b) => a?.node.name?.localeCompare(b?.node.name));
        selectedNodeBlock = {
          ...selectedNodeBlock,
          hotels: [...hotels]
        };

        contentData = {
          ...contentData,
          node: {
            ...contentData.node,
            contentBlocksTop: contentData.node?.contentBlocksTop?.map((block) => {
              if (block?.contentLink?.expanded?.contentType?.includes('AnchorLinksBlock')) {
                return {
                  ...block,
                  contentLink: {
                    ...block.contentLink,
                    expanded: selectedNodeBlock
                  }
                };
              } else {
                return block;
              }
            })
          }
        };
      }

      return contentData?.node;
    }

    return null;
  }, [data, endpoint, pageContext?.id, OptimizelyStoresContent]);

  useEffect(() => {
    setPageExternalImages(pageContentData?.externalFiles || []);
  }, [pageContentData, setPageExternalImages]);
  const updatedData = {
    content: {
      ...pageContentData,
      productsImages
    },
    endpoint
  };
  return <PageComponents data={updatedData} />;
};

export const Query = graphql`
  query {
    ...OptimizelyHomePageContent
    ...OptimizelyHomePageContentChildren
    ...OptimizelyLocationSearchPageContentChildren
    ...OptimizelyTemplatePageContentChildren
    ...OptimizelyStoresContent
    ...OptimizelyHotelsContent
  }
`;

export function Head({ pageContext, location }: HeadProps<unknown, PageContextType>) {
  const { meta, slug } = pageContext;
  return (
    <Seo
      slug={slug}
      location={location}
      title={meta?.title || ''}
      keywords={meta?.keywords || ''}
      description={meta?.description || ''}
    />
  );
}

export default ContentPageTemplate;
